<div class="card" *ngIf="candidateList">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4>{{ "LAST_CANDIDATE" | translate }}</h4>
    <a routerLink="/dashboard/candidate/list">{{ "VIEW_ALL" | translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="candidateList.length < 1">{{ "ALERT.NOT_FOUND_CANDIDATE" | translate }}</div>
    <div *ngFor="let candidate of candidateList" class="row mb-1">
      <div class="col-12">
        <a class="text-capitalize font-weight-medium text-break-line-1 mb-0" [routerLink]="'/dashboard/candidate/edit/' + candidate.hash"> {{ candidate.firstname }} {{ candidate.lastname }} </a>
        <small>
          {{ candidate.figure_name }}
        </small>
        <span
          class="badge font-small-1 badge badge-pill ml-05"
          *ngFor="let skill of candidate.skills"
          [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
        >
          {{ skill.skill_name }}
        </span>
      </div>
    </div>
  </div>
</div>
